import api from '../config/api';

const googleSheetsService = {
  // Browse spreadsheets from Google Drive
  browse: async (query = '', type = 'company') => {
    const response = await api.get('/api/google-sheets/browse', { params: { q: query, type } });
    return response.data;
  },

  // Get tabs for a spreadsheet
  getTabs: async (spreadsheetId, type = 'company') => {
    const response = await api.get(`/api/google-sheets/${spreadsheetId}/tabs`, { params: { type } });
    return response.data;
  },

  // Preview sheet data
  preview: async (spreadsheetId, sheetName = 'Sheet1', rows = 10, type = 'company') => {
    const response = await api.get(`/api/google-sheets/${spreadsheetId}/preview`, {
      params: { sheet: sheetName, rows, type },
    });
    return response.data;
  },

  // Parse a Google Sheets URL
  parseUrl: async (url, type = 'company') => {
    const response = await api.post('/api/google-sheets/parse-url', { url }, { params: { type } });
    return response.data;
  },

  // Preview schema before import
  previewSchema: async (spreadsheetId, sheetName, headerRow, type = 'company') => {
    const response = await api.post('/api/google-sheets/preview-schema', {
      spreadsheetId, sheetName, headerRow,
    }, { params: { type } });
    return response.data;
  },

  // Import a sheet into ClickHouse
  importSheet: async (params, type = 'company') => {
    const response = await api.post('/api/google-sheets/import', params, { params: { type } });
    return response.data;
  },

  // Refresh an existing import
  refresh: async (registryId, type = 'company') => {
    const response = await api.post(`/api/google-sheets/refresh/${registryId}`, {}, { params: { type } });
    return response.data;
  },

  // Delete an import
  deleteImport: async (registryId) => {
    const response = await api.delete(`/api/google-sheets/import/${registryId}`);
    return response.data;
  },

  // List all imports
  getImports: async () => {
    const response = await api.get('/api/google-sheets/imports');
    return response.data;
  },

  // Check Google Workspace connection status
  getConnectionStatus: async () => {
    const response = await api.get('/api/connectors/google-workspace/user/status');
    return response.data;
  },

  // Get LLM-suggested column mappings for an import
  suggestMapping: async (registryId) => {
    const response = await api.post(`/api/google-sheets/${registryId}/suggest-mapping`);
    return response.data;
  },

  // Get saved metadata for an import
  getMetadata: async (registryId) => {
    const response = await api.get(`/api/google-sheets/${registryId}/metadata`);
    return response.data;
  },

  // Confirm (optionally edited) mapping
  confirmMapping: async (registryId, suggestions) => {
    const response = await api.post(`/api/google-sheets/${registryId}/confirm-mapping`, { suggestions });
    return response.data;
  },

  // Update refresh mode (full or additive)
  updateRefreshMode: async (registryId, refreshMode) => {
    const response = await api.patch(`/api/google-sheets/import/${registryId}/refresh-mode`, {
      refresh_mode: refreshMode,
    });
    return response.data;
  },

  // Set or update per-sheet schedule
  updateSchedule: async (registryId, cronExpression, enabled = true) => {
    const response = await api.patch(`/api/google-sheets/import/${registryId}/schedule`, {
      cron_expression: cronExpression,
      schedule_enabled: enabled,
    });
    return response.data;
  },

  // Remove per-sheet schedule
  removeSchedule: async (registryId) => {
    const response = await api.delete(`/api/google-sheets/import/${registryId}/schedule`);
    return response.data;
  },

  // Get job history for a scheduled sheet
  getJobHistory: async (registryId, limit = 20) => {
    const response = await api.get(`/api/google-sheets/import/${registryId}/jobs`, {
      params: { limit },
    });
    return response.data;
  },
};

export default googleSheetsService;
